var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogin28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.605 3h-.103A5.451 5.451 0 0 0 9 8.395V13H5v13h19V13H10V8.403A4.451 4.451 0 0 1 14.495 4h.102A4.451 4.451 0 0 1 19 8.495l1 .01A5.45 5.45 0 0 0 14.605 3ZM6 14v11h17V14H6Zm8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 19.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
  clipRule: "evenodd"
})));
export { SvgLogin28 as ReactComponent };
export default __webpack_public_path__ + "c7f7299baac48e16d068f56970612c08.svg";